var _defs, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBaloons({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:var(--primary-color, #203c63)}.cls-2{fill:var(--secondary-color, #fff)}.cls-3{fill:var(--accent-color, #9cd3ff)}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.18 102.37a.5.5 0 01-.5-.5V87.62a.5.5 0 011 0v14.25a.5.5 0 01-.5.5zm24.31 0a.5.5 0 01-.5-.5V87.62a.5.5 0 011 0v14.25a.5.5 0 01-.5.5zm5.17-54.59a29.65 29.65 0 00-29.48-29.64H53a29.65 29.65 0 00-29.47 29.64c0 22.8 27.15 37.7 29.47 38.93v.09h.18v-.09c2.33-1.23 29.48-16.13 29.48-38.93z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.6 92.1a86.22 86.22 0 00-5.42-7.2v-.2l-.09.1-.09-.1v.2a86.22 86.22 0 00-5.42 7.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.86 48.32a.5.5 0 01-.5-.5 20.29 20.29 0 00-20.13-20.25h-.12a.5.5 0 01-.5-.5.51.51 0 01.63-.49 21.29 21.29 0 0121.12 21.24.5.5 0 01-.5.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.47 64.48a19 19 0 00-18.88-19h-.11a19 19 0 00-18.88 19c0 14.6 17.39 24.14 18.88 24.93v.06h.12v-.06c1.48-.79 18.87-10.33 18.87-24.93z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.06 92.1a55.22 55.22 0 00-3.47-4.61v-.13l-.06.06-.06-.06v.13A55.22 55.22 0 0074 92.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93 65.53a.5.5 0 01-.5-.5 15 15 0 00-14.89-15 .54.54 0 01-.54-.5.46.46 0 01.45-.5 16 16 0 0116 16 .5.5 0 01-.52.5z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaloons);
export default __webpack_public_path__ + "static/media/baloons.ecc6a2d145ad8d5ed4592a5e784e4eb3.svg";
export { ForwardRef as ReactComponent };